/* eslint-disable */
export default {
  141: 'Active',
  143: 'Deleted',
  8: 'Suspended',
  140: 'Draft',
  144: 'Paused',
  150: 'Expired'
};

